import _ from "lodash";
import {basicContext} from "../../../utils/contextUtils";

export const entities = [
    {
        name: 'AssetStatusConfiguration',
        type: "mongoInternal",
        fields: [
            'TypeOfLiberalityRecord',
            {path: 'fileStatus', type: 'YesNo'},
            {path: 'categories', type: 'TypeOfProperty', link: 'MTM', nullable: true},
        ],
    },
    {
        name: 'AssetStatus',
        fields: [
            {path: 'code', unique: true},
            {path: 'name', unique: true},
            {path: 'assetStatusConfigurations', type: 'AssetStatusConfiguration', link: 'OTM'},
        ],
        filters: [
            {
                name: 'getStatusForFileTypeAndCategory',
                isDefault: false,
                async: true,
                query: async function (context, callback) {
                    const fileNature = _.get(context, "data.fileNature")
                    const category = _.get(context, "data.category")

                    if (!fileNature) return callback(null, {_id: null})
                    const isNonLifeInsuranceAndNoCategorySelectedYet = fileNature.id !== 'lifeInsurance' && !category
                    if (isNonLifeInsuranceAndNoCategorySelectedYet) return callback(null, {_id: null})

                    const assetStatuses = await global.app.C.AssetStatus.find({
                        ...basicContext(context),
                        query: {},
                        //fieldPath: ['id']
                    })

                    const isNonLifeInsuranceAndCategorySelected = fileNature.id !== 'lifeInsurance' && category

                    const statusesForThisAsset = assetStatuses.filter(obj => {
                        const statusConfig = obj.assetStatusConfigurations.find(config => config.typeOfLiberalityRecord.id === fileNature.id)
                        if (!['yes'].includes(statusConfig?.fileStatus.id)) return false
                        //we apply category filter only in this case
                        if (isNonLifeInsuranceAndCategorySelected) return statusConfig.categories.some(c => c.id === category)
                        return true
                    })

                    return callback(null, {
                        _id: {$in: statusesForThisAsset.map(obj => new global.ObjectID(obj.id))}
                    })
                }
            }
        ]
    }
]
